import * as Yup from 'yup'

import { PriceBandData } from 'adminConsole/store'

let priceBandSchema = Yup.object({
  dealerNo: Yup.string().trim().oneOf(['TK3C']).required(),
  productCategory: Yup.string().trim().oneOf(['phone', 'accessories', 'laptop']).required(),
  paymentType: Yup.string().trim().oneOf(['M', '1Y', '2Y', '3Y']).required(),
  scopeType: Yup.string().trim().required(),
  productType: Yup.string().trim().required(),
  premium: Yup.number().integer().min(0).required(),
  priceMin: Yup.number().integer().min(0).required(),
  priceMax: Yup.number().integer().min(0).required(),
  chgDeductible: Yup.number().integer().min(0).required(),
  fixDeductible: Yup.number().integer().min(0),
})

export const validatePriceBands = (priceBands: PriceBandData[]) => {
  let validPriceBands: PriceBandData[] = []
  let invalidPriceBands: PriceBandData[] = []

  const errorMap: Record<string, Record<string, string>> = {}

  priceBands.forEach(priceBand => {
    try {
      priceBandSchema.validateSync(priceBand, { abortEarly: false })
      validPriceBands.push(priceBand)
    } catch (error: any) {
      invalidPriceBands.push(priceBand)

      const fieldErrors: Record<string, string> = {}
      error.inner.forEach((err: Yup.ValidationError) => {
        if (err.path && !fieldErrors[err.path]) fieldErrors[err.path] = err.message
      })
      const key = `${priceBand.productCategory}-${priceBand.productType}`
      errorMap[key] = fieldErrors
    }
  })

  if (process.env.REACT_APP_ENV_TYPE !== 'production') console.log('保險級距檢核未通過:', errorMap)

  return { validPriceBands, invalidPriceBands }
}
